const cacheImpressions = {
  impressionsSent: [] as string[],
};

const cacheViewItems = {
  impressionsSent: [] as string[],
};

export const clearImpressionDesignsSent = () => {
  cacheImpressions.impressionsSent = [];
};

export const getNotSendDesigns = (designs: any[], positions: number[], cacheToUse: { impressionsSent: string[] }) =>
  designs
    .filter((design) => {
      if (!design?.designIdEncLocale) {
        return false;
      }

      // if design was sent before skip it
      return cacheToUse.impressionsSent.indexOf(design.designIdEncLocale) <= -1;
    })
    .map((design, index) => {
      // register designs which were no sent yet
      cacheToUse.impressionsSent.push(design.designIdEncLocale);

      return {
        ...design,
        list: 'Category Page',
        position: Number(positions[index]),
      };
    })
    .filter((design) => design);

export const gtmProductImpressionEvent = (designs: any[], positions: number[]) => {
  // filter designs which was not sent yet
  const impressions = getNotSendDesigns(designs, positions, cacheImpressions);

  if (!impressions.length) {
    return undefined;
  }

  return {
    event: 'productImpression',
    ecommerce: {
      currencyCode: 'NOK',
      impressions,
    },
  };
};
